/**
 * House rule "no em/en dashes" for agent chrome whose words come from the server (agent definitions in the cowork
 * API). DollarStore staging sim r4 showed "ACMO — Agentic CMO", "Your marketing co-pilot — let's make great things
 * happen" and the trait badge "Direct — answer first". The server copy is being fixed too; this guard keeps the chat
 * chrome plain whatever the server sends. Hyphens inside words ("co-pilot", "end-to-end") are left alone.
 *
 * - A spaced dash between words becomes `sep`: ": " for titles and badges, ", " for taglines.
 * - A dash between two numbers ("1–3") becomes a hyphen.
 * - Any other dash becomes `sep` (leading/trailing ones are dropped).
 */
const NUMBER_RANGE = /(\d)\s*[–—]\s*(?=\d)/g;
const SPACED = /\s*[–—]\s*/g;

export function plainDashes(text: string, sep: ': ' | ', ' = ': '): string {
  if (!text || !/[–—]/.test(text)) return text;
  return text
    .replace(NUMBER_RANGE, '$1-')
    .replace(SPACED, (match: string, offset: number, whole: string) => {
      const atEdge = !whole.slice(0, offset).trim() || !whole.slice(offset + match.length).trim();
      return atEdge ? '' : sep;
    })
    .trim();
}

/** "ACMO — Agentic CMO" → "ACMO: Agentic CMO" */
export const plainTitle = (text: string | undefined | null): string => plainDashes(text ?? '', ': ');

/** "Your marketing co-pilot — let's make great things happen" → "Your marketing co-pilot, let's make great things happen" */
export const plainTagline = (text: string | undefined | null): string => plainDashes(text ?? '', ', ');
